const HEIC_QUALITY = 0.8;

/**
 * HEIC URL → 변환된 jpeg Object URL.
 *
 * heic-to 라이브러리가 jpeg 인코딩 단계에서 `document.createElement("canvas")` 를 사용하므로
 * Web Worker 환경에서는 동작할 수 없다. 따라서 변환은 항상 메인 스레드에서 수행한다.
 *
 * 메인 스레드 jank 는 다음으로 완화한다:
 * - {@link HeicConversionQueue} 의 동시성 제한 (기본 2)
 * - 백그라운드 탭에서는 큐의 `pauseOnHidden` 옵션으로 신규 변환 중단
 *
 * heic-to 와 그 의존성(libheif WASM, 약 수 MB) 은 dynamic import 로 첫 변환 시점에만 로드되어
 * 초기 번들 크기에 영향을 주지 않으며, vite-plugin-pwa 의
 * `globIgnores: ["assets/heic-to-*.js"]` 와 호환되어 SW precache 에도 들어가지 않는다.
 */
export async function convertHeicToJpegUrl(src: string): Promise<string> {
  const response = await fetch(src);
  if (!response.ok) throw new Error(`Failed to fetch HEIC source (status ${response.status})`);
  const heicBlob = await response.blob();

  const { heicTo } = await import("heic-to");
  const jpegBlob = await heicTo({ blob: heicBlob, type: "image/jpeg", quality: HEIC_QUALITY });

  return URL.createObjectURL(jpegBlob);
}
